import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { Box, styled, Typography } from '@mui/material';
import LoadingSpinner from '../../../components/loadingSpinner';
import { ServerErrorModal } from '../../../sharedComponents/Error';
import { AxiosError } from 'axios';

// Overrides to make a height 100% work
const GlobalOverridesStyle = createGlobalStyle`
    body {
        height: 100%;
        padding-bottom: 0;

        .wrapper {
            height: 100%;
            display: flex;
            flex-direction: column;
            padding-bottom: 0;
        }
    }
`;

const Container = styled(Box)(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: theme.spacing(3),
  paddingBottom: 0,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
    paddingBottom: 0,
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
    paddingBottom: 0,
  },
  '@media (max-height: 600px)': {
    padding: theme.spacing(1.5),
    paddingBottom: 0,
  },
}));

const PageHeading = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  flex: '0 0 auto',
  margin: 0,
  marginBottom: theme.spacing(2),
  padding: 0,
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    fontSize: '24px',
    lineHeight: '28px',
    marginBottom: theme.spacing(1.5),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
    lineHeight: '24px',
    marginBottom: theme.spacing(1.5),
  },
  '@media (max-height: 600px)': {
    fontSize: '18px',
    lineHeight: '22px',
    marginBottom: theme.spacing(1),
  },
}));

const BodyArea = styled(Box)({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: 0,
});

const StyledIframe = styled('iframe')({
  border: 0,
  flex: 1,
  minHeight: 0,
  width: '100%',
});

interface TrevorDashboardBodyProps {
  iframeUrl: string;
  isFetching: boolean;
  error?: AxiosError;
}

const TrevorDashboardBody: React.FC<TrevorDashboardBodyProps> = ({
  iframeUrl,
  isFetching,
  error,
}) => {
  let body = null;

  if (isFetching) {
    body = <LoadingSpinner />;
  } else if (error) {
    body = <ServerErrorModal />;
  } else if (iframeUrl) {
    body = <StyledIframe role="iframe" title="Onboarding Forms Usage Dashboard" src={iframeUrl} />;
  }

  return (
    <>
      <GlobalOverridesStyle />
      <Container>
        <PageHeading variant="h1">Onboarding Forms Usage Dashboard</PageHeading>
        <BodyArea>{body}</BodyArea>
      </Container>
    </>
  );
};

export default TrevorDashboardBody;
